export default "__VITE_ASSET__BeXodtTp__"